import { Divider, Layout } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import useAuth from '../../auth/useAuth';
import { White } from '../../styles';
import EmailVerification from '../EmailVerification';
import Loading from '../Loading';
import NavBar from '../NavBar';

const { Content } = Layout;

const StyledLayout = styled(Layout)`
  display: flex;
  flex-flow: column;
  height: 100%;
  font-family: 'Roboto', sans-serif;
  background: ${White};
`;

const StyledContent = styled(Content)`
  flex: 1;
  overflow: auto;
`;

const StyledDivider = styled(Divider)`
  margin: 0;
`;

function PageLayout({ signupComplete = false, showNavBar = true }) {
  const { isLoading, isAuthenticated } = useAuth();
  const context = useOutletContext();

  if (isLoading) {
    return <Loading />;
  }

  return (
    <StyledLayout>
      {showNavBar && (
        <>
          <NavBar signupComplete={signupComplete} />
          <StyledDivider />
          {isAuthenticated && signupComplete && <EmailVerification />}
        </>
      )}
      <StyledContent>
        <Outlet context={context} />
      </StyledContent>
    </StyledLayout>
  );
}

PageLayout.propTypes = {
  signupComplete: PropTypes.bool,
  showNavBar: PropTypes.bool,
};

export default PageLayout;
